import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

const TriggerPickerItem = ({
  trigger,
  categoryLabel,
  isSelected = false,
  onOpen,
  variant = 'dark',
  icon: Icon,
  iconClassName,
}) => {
  const TriggerIcon = Icon || trigger.icon;
  const isDark = variant === 'dark';

  return (
    <button
      type="button"
      onClick={() => onOpen?.(trigger)}
      className={cn(
        'group flex w-full items-center gap-3 rounded-2xl border p-3 text-left transition-all',
        isDark
          ? isSelected
            ? 'border-emerald-500/50 bg-emerald-500/10'
            : 'border-transparent hover:border-zinc-700 hover:bg-zinc-800'
          : isSelected
            ? 'border-teal-500 bg-teal-50'
            : 'border-transparent hover:bg-slate-50',
      )}
      data-testid={`trigger-picker-item-${trigger.id}`}
      aria-label={`Configure ${trigger.name}`}
    >
      <div
        className={cn(
          'flex h-12 w-12 shrink-0 items-center justify-center rounded-xl',
          iconClassName || (isDark ? 'bg-zinc-800' : 'bg-slate-100'),
        )}
      >
        {TriggerIcon ? (
          <TriggerIcon
            size={20}
            className={isDark ? 'text-emerald-400' : 'text-teal-600'}
          />
        ) : null}
      </div>

      <div className="min-w-0 flex-1">
        <div className={cn('font-semibold text-sm', isDark ? 'text-white' : 'text-slate-900')}>
          {trigger.name}
        </div>
        {trigger.description ? (
          <div className={cn('mt-0.5 text-xs line-clamp-2', isDark ? 'text-zinc-400' : 'text-slate-500')}>
            {trigger.description}
          </div>
        ) : null}
        {categoryLabel ? (
          <div className={cn('mt-1 text-[10px] uppercase tracking-wide', isDark ? 'text-zinc-500' : 'text-slate-400')}>
            {categoryLabel}
          </div>
        ) : null}
        {trigger.eventKey ? (
          <div className={cn('mt-0.5 text-[10px] font-mono', isDark ? 'text-emerald-400/80' : 'text-teal-600')}>
            {trigger.eventKey}
          </div>
        ) : null}
      </div>

      <ChevronRight
        size={18}
        className={cn(
          'shrink-0 transition-colors',
          isDark
            ? 'text-zinc-500 group-hover:text-zinc-300'
            : 'text-slate-400 group-hover:text-slate-600',
        )}
        aria-hidden
      />
    </button>
  );
};

export default TriggerPickerItem;
